module.exports = __webpack_public_path__ + "img/banner-wenzi.d78d09dc.png";